import { Navigate, useParams } from "react-router";
import { useEnhancedBiApiClientProvider } from "../../contexts/ApiClientProviderContext";
import { useClientContext } from "../../contexts/ClientContext";
import useDefineViewReportData from "../../hooks/useDefineViewReportData";
import { getAdminPortalViewReportUrl } from "./getAdminPortalReportUrls";
import RedirectToAdminPortal from "./RedirectToAdminPortal";
import ReportNotFoundOrAccessForbidden from "./ReportNotFoundOrAccessForbidden";

const ViewRoot = () => {
  const { id } = useParams();
  const { clientCode } = useClientContext();
  const { getReportsUrl } = useEnhancedBiApiClientProvider();
  const { showReportNotFound } = useDefineViewReportData();

  if (id === undefined) {
    return <Navigate to={getReportsUrl(clientCode)} />;
  }

  if (showReportNotFound === true) {
    return <ReportNotFoundOrAccessForbidden getReportsUrl={getReportsUrl} />;
  }
  return <RedirectToAdminPortal url={getAdminPortalViewReportUrl(clientCode, id)} />;
};

export default ViewRoot;
